import * as React from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Link, useNavigate } from "react-router-dom";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  createTheme,
  PaletteColorOptions,
  ThemeProvider,
} from "@mui/material/styles";
import { Stack } from "@mui/material";
import logo from "./Geekay-logo.png";

export default function ChallanMenu() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const { palette } = createTheme();
  const { augmentColor } = palette;
  const createColor = (mainColor) =>
    augmentColor({ color: { main: mainColor } });
  const theme = createTheme({
    palette: {
      anger: createColor("#F40B27"),
      apple: createColor("#A38A00"),
      steelBlue: createColor("#5C76B7"),
      violet: createColor("#BC00A3"),
    },
    button: {
      // Here is where you can customise the button
      fontSize: 16,
      fontWeight: 1700,
    },
  });

  return (
    <div> <ThemeProvider theme={theme}>
      <Button color='apple'
      position='static'
      style={{ fontWeight: '1000', fontSize: '17px' }}
      display="flex"
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon />}
      >
        Challan
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem component={Link} to="/certificates/show_chalans" onClick={handleClose} color="apple">IDLR</MenuItem>
        <MenuItem component={Link} to="/certificates/show_inds_chalans" onClick={handleClose}>Industial</MenuItem>
      </Menu>
      </ThemeProvider>
    </div>
  );
}
